import React from 'react'
import { Dropdown } from 'semantic-ui-react'
import { openExternal } from '../../../../global/viewSettings/helpers/settingsLinks'

const ParentKeysDd = (props) => {

  const { parentDataKeys, pathViews } = props

  const handleOpenDb = (key, value) => {
    let _key;
    switch (key) {
      case 'matches':
      case 'playoffMatches':
      case 'scores':
      case 'playoffScores':
        _key = '_matches_seasonal';
        break;
      default:
        _key = '_' + key

    }
    openExternal.firebaseDb(pathViews, _key, value)
  }

  const dropdown = () => {

    if (parentDataKeys) {
      // const _options = _.map(parentDataKeys, (item, key) => (
      //   { description: item, text: key }
      // ))
      const ddis = _.map(parentDataKeys, (item, key) => {
        switch (key) {
          case 'details':
            break;
          default:
            return <Dropdown.Item description={item} text={key} onClick={() => { handleOpenDb(key, item) }} />
        }
      })

      return <Dropdown
        text='Parent Data Keys'
        floating
        labeled
        button
        icon='filter'
        className='icon mini ddl-full black app-dark-mode'
        direction='left'
      // options={_options}
      >
        <Dropdown.Menu>
          {ddis}
        </Dropdown.Menu>
      </Dropdown>
    }
  }

  return dropdown()

}

export default ParentKeysDd